module.exports = __webpack_public_path__ + "img/vue1-corpsarr_bleu.f197e608.png";